import { useCallback } from 'react';
import { useTracking } from '@edreamsodigeo/frontend-core';
import { usePerformedSearchRequest } from 'clientState/providers/SearchRequestProvider';
import { useSortingTypeLabel } from '@components/Sorting/Provider';
import { RESULTS_CATEGORY } from 'clientState/providers/TrackingProviders';
import { format } from 'date-fns';
import { useItineraryPosition } from '@components/Results/Components/Itinerary/Provider';

const getTabLabel = (tab) => {
  const tabs = {
    recom: 'recom',
    price: 'cheap',
    duration: 'fast',
  };

  return tabs[tab];
};

const getRouteTrackingLabel = (searchRequest) => {
  const segments = searchRequest?.itinerary?.segments;
  return segments?.map((segment) => `${segment?.departure?.iata}`).join('-');
};

const getDatesTrackingLabel = (searchRequest) => {
  const segments = searchRequest?.itinerary?.segments;
  return segments
    ?.map((segment) => `${format(new Date(segment?.date), 'dd/MM')}`)
    .join('-');
};

const getFavoriteOnClickLabelElements = (
  tripType = '',
  sortingTypeLabel,
  position,
  searchRequest
) => {
  const trackingElements = [
    'select-favorite',
    `trip-type:${tripType
      .split('_')
      .reduce((type, str) => type + str.charAt(0), '')}`,
    `route:${getRouteTrackingLabel(searchRequest)}`,
    `dates:${getDatesTrackingLabel(searchRequest)}`,
    `position:${position + 1}`,
    `tab:${getTabLabel(sortingTypeLabel)}`,
    `page:fl_res`,
  ];

  return trackingElements;
};

const useFavoriteResultsTracking = () => {
  const { trackEvent } = useTracking();
  const searchRequest = usePerformedSearchRequest();
  const sortingTypeLabel = useSortingTypeLabel();
  const index = useItineraryPosition();
  const tripType = searchRequest ? searchRequest.tripType : '';
  const sendTracking = useCallback(() => {
    trackEvent({
      category: RESULTS_CATEGORY,
      action: 'favorites',
      label: getFavoriteOnClickLabelElements(
        tripType,
        sortingTypeLabel,
        index,
        searchRequest
      ).join('_'),
    });
  }, [trackEvent, searchRequest, sortingTypeLabel, tripType, index]);
  return sendTracking;
};

export default useFavoriteResultsTracking;
